/** Must match `recordMapCarouselEvent` slideId validation (Cloud Function). */
const MAP_CAROUSEL_EVENT_SLIDE_ID_RE = /^[a-zA-Z0-9_-]{8,128}$/;

export function isValidMapCarouselSlideId(id) {
  return typeof id === "string" && MAP_CAROUSEL_EVENT_SLIDE_ID_RE.test(id);
}
